<template>
    <div class="exam" v-if="lessonExam">
        <div class="timer" v-if="timeing!==0">
            <img src="@/assets/img/hours-w.png" alt="" v-if="mime">
            <img src="@/assets/img/hours.png" alt="" v-else> {{timeingStr}}
        </div>
        <div class="lesson-name" v-if="lastLessonName!==''">{{lastLessonName}}</div>
        <component :is="examType" @ans="ans" @end="timeEnd"></component>
    </div>
</template>

<script>
import mainDelegate from '@/delegate/mainDelegate'
import examDelegate from '@/delegate/examDelegate'
import Exam_0 from '@/components/Exam_0'
import Exam_1 from '@/components/Exam_1'
import Exam_2 from '@/components/Exam_2'
import Exam_3 from '@/components/Exam_3'
import Exam_4 from '@/components/Exam_4'
import ExamEnd from '@/components/ExamEnd'
export default {
    name: 'Exam',
    mixins: [mainDelegate, examDelegate],
    data() {
        return {
            lastLessonName: ''
        }
    },
    computed: {
        mime() {
            return this.$store.state.stageWw < 1000
        },
        timeingStr() {
            let t1 = this.examDuration - this.timeing
            let t2 = ~~(t1 / 60)
            let t3 = t1 % 60 + ''
            t3 = t3.length === 1 ? 0 + t3 : t3
            return t2 + ':' + t3
        },
        lessonName() {
            return this.question
                ? this.question.VocabularyModel.LessonName
                : this.lastLessonName
        },
        examType() {
            if (this.examId === -1) {
                return 'ExamEnd'
            }
            switch (this.question.Type) {
                case 0:
                    return 'Exam_0'
                    break
                case 1:
                    return 'Exam_1'
                    break
                case 2:
                    return 'Exam_2'
                    break
                case 3:
                    return 'Exam_3'
                    break
                case 4:
                    return 'Exam_4'
                    break
                default:
                    alert('未知的題目類型', this.optionModel[this.examId].Type)
            }
        }
    },
    components: {
        Exam_0,
        Exam_1,
        Exam_2,
        Exam_3,
        Exam_4,
        ExamEnd
    },
    methods: {
        timeEnd() {
            this.timeEndExam()
        },
        ans(val) {
            if (this.isExamEnd) {
                this.endExam()
                this.$emit('end')
            } else {
                this.nextExam()
            }
        }
    },
    watch: {
        lessonExam(val) {
            if (val && val.QuestionModel && val.QuestionModel.length > 0) {
                //有題目
            } else {
                //沒有題目倒回首頁
                alert(this.$t('noQuestionModel'))
                this.$router.replace({ name: 'main' })
            }
        },
        lessonName(val) {
            this.lastLessonName = val
        }
    },
    beforeRouteLeave(to, from, next) {
        this.clearLessonExam()
        next()
    }
}
</script>

<style lang="less" scoped>
@import 'val.less';
.exam {
    max-width: 480px;
    margin: 0px auto;
}
.vocabulary {
    min-height: 100px;
    margin: 10px 10px 50px 10px;
    padding: 0px 10px 5px 0px;
    border: @main-color solid 2px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    color: @main-color;
}
.option {
    .item {
        padding: 0px 20px;
        font-size: 20px;
        line-height: 55px;
        text-align: left;
        .txt {
            display: inline-block;
        }
        .icon {
            float: right;
        }
        &::before {
            content: '';
            display: inline-block;
            width: 10px;
            height: 10px;
            margin: 0px 10px 2px 0px;
            background: @main-color;
            border-radius: 5px;
        }
        &:active {
            background: #eff6f6;
        }
    }
}
.lesson-name {
    text-align: left;
    margin: 15px;
    font-size: 24px;
    color: @main-color;
}
.timer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    background-color: #4a90e2;
    font-size: 24px;
    letter-spacing: 0.9px;
    color: #fff;
    img {
        margin-right: 10px;
    }
}
@media only screen and (min-width: @rwd) {
    .lesson-name {
        margin: 0px;
        margin-bottom: 30px;
    }
    .timer {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 31px;
        top: 62px;
        font-size: 60px;
        letter-spacing: 2.1px;
        color: #4a90e2;
        background-color: transparent;
        img {
            margin-right: 0px;
            transform: translate(30px, -30px);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/Exam.vue